import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_GET_OVERVIEW_METHOD = "GET";
export const SUBSCRIPTIONS_CUSTOMER_GET_OVERVIEW_PATH_SUFFIX = "/overview";
/** /customer/subscription/overview */
export const SUBSCRIPTIONS_CUSTOMER_GET_OVERVIEW_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_GET_OVERVIEW_PATH_SUFFIX
}`;
